import getPrintTemplatesByEntityConfIdFlow from './getPrintTemplatesByEntityConfId/epic';
import getPrintTemplatesByNameFlow from './getPrintTemplatesByName/epic';
import { combineEpics } from 'redux-observable';
export default combineEpics(getPrintTemplatesByEntityConfIdFlow, getPrintTemplatesByNameFlow);
